const ttsStore = {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {},
    modules: {}
};
export default ttsStore;
